const normalizeText = (value) => String(value ?? "").trim();

export const isComboGoodsItem = (item = {}) => (
  Number(item?.itemType || 0) === 2 && !!normalizeText(item?.comboCode)
);

export const resolveGoodsTitle = (item = {}) => (
  normalizeText(
    item?.comboName
      || item?.title
      || item?.subject
      || item?.spuName
      || item?.name
  )
);

export const resolveGoodsDetailLink = (item = {}, fallbackTitle = "") => {
  const title = normalizeText(fallbackTitle) || resolveGoodsTitle(item);

  if (isComboGoodsItem(item)) {
    const comboCode = normalizeText(item.comboCode);
    const dealerShopId = normalizeText(item.dealerShopId);
    const slug = encodeURIComponent(title || comboCode);
    const dealerShopQuery = dealerShopId
      ? `&dealerShopId=${encodeURIComponent(dealerShopId)}`
      : "";

    return `/product/${slug}?comboCode=${encodeURIComponent(comboCode)}${dealerShopQuery}`;
  }

  if (item?.link) {
    return item.link;
  }

  const detailId = item?.id || item?.spuId || item?.offerId || item?.itemSpuId;
  if (detailId) {
    return `/product?detailId=${encodeURIComponent(String(detailId))}`;
  }

  if (title) {
    return `/product/${encodeURIComponent(title)}`;
  }

  return "#";
};
